import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ACTIVATIONS_BASE_PATH } from '../utils/pathsConstants';

export interface ActivationWithService {
    id: string | number;
    startDate: string;
    endDate?: string;
    url?: string;
    type: string;
    service: string;
}

interface GetAllActivationsResponse {
    activations: ActivationWithService[];
}

const QUERY_KEY = 'activations';

async function fetchActivations(): Promise<ActivationWithService[]> {
    const { data } = await axios.get<GetAllActivationsResponse>(
        `/api/${ACTIVATIONS_BASE_PATH}/activations`,
    );
    return data.activations;
}

export function useActivations() {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: [QUERY_KEY],
        queryFn: fetchActivations,
    });

    return {
        activations: data ?? [],
        isLoading,
        error,
        refetch,
    };
}
